<!--
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:48
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2022-07-28 10:39:12
 * @FilePath: \frontend\src\components\SvgIcon\index.vue
-->
<template>
  <!-- deleted v-on='$listeners, check effect'-->
  <!--
  <div v-if="isExternal" v-bind="$attrs" :style="styleExternalIcon" class="svg-external-icon svg-icon" />
  <svg v-else v-bind="$attrs" :class="svgClass" aria-hidden="true">
    <use :href="iconName" />
  </svg>
  -->
  <svg v-bind="$attrs" :class="svgClass" aria-hidden="true">
    <use :href="iconName" />
  </svg>
</template>

<script>
// doc: https://panjiachen.github.io/vue-element-admin-site/feature/component/svg-icon.html#usage
// import { isExternal } from '@/utils/validate';

export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
  },
  computed: {
    // isExternal() {
    //   return isExternal(this.iconClass);
    // },
    iconName() {
      return `/__spritemap#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    },
    // styleExternalIcon() {
    //   return {
    //     mask: `url(${this.iconClass}) no-repeat 50% 50%`,
    //     '-webkit-mask': `url(${this.iconClass}) no-repeat 50% 50%`,
    //   };
    // },
  },
};
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-external-icon {
  background-color: currentColor;
  mask-size: cover !important;
  display: inline-block;
}
</style>
